import React, { useState, useEffect } from "react";
import Button from "../../../../Elements/Button/Button.js";
import Tooltip from "../../../../Elements/Tooltip/Tooltip.js";
import config from "config";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import CreateEmbedPageModalSecondStep from "./CreateEmbedPageModalSecondStep.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../../contexts/userContext/userContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

const CreateEmbedPageModalNew = ({
  createPage,
  dynamicFormsList = null,
  loadingCreatePage,
  setLoadingCreatePage,
}) => {
  const { getUserData } = useUser();
  const { addToast } = useToasts();
  const userData = getUserData();
  const { closeModal } = useModal();
  const [isStep1, setIsStep1] = useState(true);
  const { getTextByKey, getPath } = useContent();
  const [loadingPage, setLoadingPage] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [loadingNum, setLoadingNum] = useState(3);
  const [emptyCompanyName, setEmptyCompanyName] = useState(false);
  const [userNameUrl, setUserNameUrl] = useState("");
  const [emptyUserNameUrl, setEmptyUserNameUrl] = useState(false);
  const [invalidCompanyName, setInvalidCompanyName] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const maxLimit = 30;
  const minNum = 0;
  useEffect(() => {
    if (loadingPage) {
      if (loadingNum > minNum) {
        setTimeout(() => {
          setLoadingNum((prev) => --prev);
        }, 1000);
      } else if (loadingNum === 0) {
        setTimeout(() => {
          let embedPage =
            config.baseurl + getPath() + "page-edit/" + userData.UserId;
          window.location.href = embedPage;
        }, 1000);
      }
    }
  }, [loadingNum, loadingPage]);

  const handleChangeCompanyName = (e) => {
    setEmptyCompanyName(false);
    if (e.length <= maxLimit) {
      setInvalidCompanyName(false);
      setCompanyName(e);
    }
  };

  const renderSecondStepModal = () => {
    let continueToStep2 = true;
    //need to check if company name is empty or invalid
    if (!companyName) {
      continueToStep2 = false;
      setEmptyCompanyName(true);
    }

    if (companyName.length > maxLimit) {
      setInvalidCompanyName(true);
      continueToStep2 = false;
    }

    if (dynamicFormsList.length === 1) {
      if (continueToStep2) {
        setLoadingButton(true);
        createPage({
          companyName,
          setLoadingPage,
        });
      } else {
        console.log("error create page");
      }
    } else {
      setIsStep1(!continueToStep2);
    }
  };

  const createPageWithoutForms = () => {
    let continueToStep2 = true;
    if (!companyName) {
      continueToStep2 = false;
      setEmptyCompanyName(true);
    }

    if (companyName.length > maxLimit) {
      setInvalidCompanyName(true);
      continueToStep2 = false;
    }
    if (continueToStep2) {
      setLoadingButton(true);
      createPage({
        companyName,
        setLoadingPage,
      });
    }
  };

  return (
    <>
      {isStep1 ? (
        <div className="create-page-modal-new">
          <div className="create-page-modal-header">
            <h1>{getTextByKey("create-your-page")}</h1>
            <p>{getTextByKey("create-your-page-subtitle")}</p>
          </div>
          <div className="inputs">
            <div
              className={`item ${
                companyName.length >= maxLimit ? "max-limit" : ""
              } `}
            >
              <div className="title-input">
                <span className="span-label">
                  {getTextByKey("business-name-text-modal")}
                </span>{" "}
                <Tooltip
                  id={"business-name"}
                  tooltipTextKey="business-name-tooltip-modal"
                  //hardPositioned
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>
              <div
                className={`div-input ${emptyCompanyName ? "empty-field" : ""}`}
              >
                <input
                  value={companyName}
                  type="text"
                  onChange={(e) => {
                    handleChangeCompanyName(e.target.value);
                  }}
                />
              </div>
              {emptyCompanyName ? (
                <div className="empty-field-text">
                  <span> {getTextByKey("empty-field-text")}</span>
                </div>
              ) : (
                <div className="max-chars">
                  <span className="show-chars" style={{ direction: "ltr" }}>
                    {companyName.length} / {maxLimit}
                  </span>
                </div>
              )}
            </div>
            {loadingPage ? (
              <div className="show-loading">
                <div className="circle-container">
                  <span>{loadingNum}</span>
                </div>
              </div>
            ) : (
              <div className="submit-div">
                {dynamicFormsList.length > 1 ? (
                  <Button onClick={() => renderSecondStepModal()}>
                    {getTextByKey("check-status-button")}
                  </Button>
                ) : (
                  <Button onClick={() => createPageWithoutForms()}>
                    {loadingButton ? (
                      <Image alt="" title="" name="preloader" ext="gif" />
                    ) : (
                      getTextByKey("create-page")
                    )}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <CreateEmbedPageModalSecondStep
          setLoadingButton={setLoadingButton}
          companyName={companyName}
          userNameUrl={userNameUrl}
          maxLimit={maxLimit}
          setLoadingPage={setLoadingPage}
          loadingPage={loadingPage}
          loadingNum={loadingNum}
          setEmptyCompanyName={setEmptyCompanyName}
          setEmptyUserNameUrl={setEmptyUserNameUrl}
          createPage={createPage}
          dynamicFormsList={dynamicFormsList}
        />
      )}
    </>
  );
};

export default CreateEmbedPageModalNew;
